// components/CustomDialog.jsx
import React from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from '@mui/material';

const CustomDialog = ({ open, title, content, onClose, onConfirm }) => {
  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>{content}</DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancelar</Button>
        {onConfirm && (
          <Button onClick={onConfirm} variant="contained" color="error">
            Confirmar
          </Button>
        )}
      </DialogActions>
    </Dialog>
  );
};

export default CustomDialog;
